import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "ta-c" };
const _hoisted_2 = { class: "ta-c" };
const _hoisted_3 = { class: "ta-r" };
const _hoisted_4 = { class: "ta-c" };
const _hoisted_5 = { class: "ta-c" };
const _hoisted_6 = { class: "ta-c" };
const _hoisted_7 = { class: "ta-c" };
import dateFormatType from '@/constants/dateFormatType';
import { routeName } from '@/constants/routeName';
import { isTodayTextColor, formatDate, } from '@/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Table',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        /**
         * 링크 경로
         */
        const to = () => {
            const { id } = props.item;
            return {
                name: routeName.BAROMONEY_TRANSFER_SETTING_DETAIL,
                params: {
                    baromoneyTransferSettingId: id,
                },
            };
        };
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", _hoisted_1, [
                    _createVNode(_component_router_link, {
                        class: "cy-link",
                        to: to()
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.item.sourceName), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                ]),
                _createElementVNode("td", _hoisted_2, [
                    _createVNode(_component_router_link, {
                        class: "cy-link",
                        to: to()
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.item.targetName), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                ]),
                _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.item.moveFix), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.item.isDeletedToString), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("span", {
                        class: _normalizeClass(_unref(isTodayTextColor)(props.item.createdAt))
                    }, _toDisplayString(_unref(formatDate)(props.item.createdAt, _unref(dateFormatType).DATE)), 3 /* TEXT, CLASS */)
                ]),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.item.applyDate), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.item.expireDate), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(_ctx.item.moveMemo), 1 /* TEXT */)
            ]));
        };
    }
});
